function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, useCallback, useContext } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { useModalStepsContext } from "./ModalStepsContext";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ModalContext = /*#__PURE__*/createContext({
  close: () => {},
  isOpen: false,
  open: () => {}
});
export var ModalContextProvider = _ref => {
  var {
    children
  } = _ref;
  var modalContext = useModalContext();
  return ___EmotionJSX(ModalContext.Provider, {
    value: modalContext
  }, children);
};
export function withModalContext(Component) {
  var ComponentWithModalContext = _ref2 => {
    var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
    var context = useContext(ModalContext);
    return ___EmotionJSX(Component, _extends({}, context, props));
  };
  return ComponentWithModalContext;
}
export function useModalContext() {
  var {
    isOpen,
    onClose,
    onOpen: open
  } = useDisclosure();
  var {
    goToStep
  } = useModalStepsContext();
  var close = useCallback(() => {
    onClose();
    setTimeout(() => {
      goToStep(0);
    }, 500);
  }, [goToStep, onClose]);
  return {
    close,
    isOpen,
    open
  };
}